module.exports = __webpack_public_path__ + "img/icon-gratis-versand.810e2c0f.svg";